/** 본인 인증 요청 시 전달하는 사이트 식별자 */
export const CERTIFICATION_SITE = 'encar-withdrawal';

/** 인증번호 자리수 */
export const CERTIFICATION_CODE_LENGTH = 5;

/** 인증번호 유효 시간(분) */
export const CERTIFICATION_CODE_EXPIRE_MINUTES = 3;

/** 인증번호 남은 시간 타이머 갱신 주기(ms) */
export const CERTIFICATION_TIMER_INTERVAL_MS = 500;

/** 인증번호 재요청 연타 방지 시간(ms) */
export const CERTIFICATION_REAPPLY_THROTTLE_MS = 5000;

/** 인증번호 최대 재요청 횟수 */
export const MAX_REAPPLY_COUNT = 5;

/** SNS 재인증 세션 유효 시간(시간) - myInfoAccess와 동일하게 2시간 */
export const SNS_REAUTH_SESSION_EXPIRE_HOURS = 2;

/** 탈퇴 사유 - '기타' 선택 시 식별자 (BE leaveType: ETC) */
export const WITHDRAW_REASON_ETC = 'ETC';

/** 탈퇴 사유 - '기타' 자유입력 최소 글자 수 */
export const WITHDRAW_REASON_MIN_LENGTH = 10;

/** 탈퇴 사유 - '기타' 자유입력 최대 글자 수 (한글 기준 50자) */
export const WITHDRAW_REASON_MAX_LENGTH = 50;

/**
 * 탈퇴 사유 선택 항목 - value는 BE leaveType 코드 (마지막 '기타'는 자유입력 노출)
 * value는 `@encarpkg/api`의 WithdrawLeaveType과 동일한 값만 허용됨
 * @type {Array<{ value: import('@encarpkg/api').WithdrawLeaveType, label: string }>}
 */
export const WITHDRAW_REASONS = [
	{ value: 'UNSATISFIED_SERVICE', label: '서비스가 만족스럽지 않아서' },
	{ value: 'CREATE_NEW_ID', label: '새로운 아이디를 만들기 위해' },
	{ value: 'SWITCH_TO_OTHER_SERVICE', label: '타사 서비스로 전환하기 위해서' },
	{ value: 'FREQUENT_SERVICE_ERROR', label: '잦은 서비스 오류 및 장애 때문에' },
	{ value: 'RARELY_USED', label: '서비스 이용을 거의 하지 않아서' },
	{ value: 'SERVICE_RESTRICTED', label: '서비스 이용에 제한을 받아서' },
	{ value: WITHDRAW_REASON_ETC, label: '기타' }, // BE label: '기타 (엔카에 바라는 점)'
];

/** 회원 탈퇴 - 탈퇴 확인 모달 문구 */
export const WITHDRAW_CONFIRM_MODAL = {
	TITLE: '정말 탈퇴하시겠습니까?',
	SUBTITLE: '회원 탈퇴 시 엔카 서비스를\n더 이상 이용할 수 없습니다.',
	CANCEL: '취소',
	SUBMIT: '탈퇴',
};

/** 회원 탈퇴 - 탈퇴 신청 제출 시점 SNS 재인증 세션 만료 안내 모달 문구 */
export const WITHDRAW_SNS_EXPIRED_MODAL = {
	TITLE: 'SNS 인증이 만료되어\n탈퇴를 완료하지 못했어요',
	SUBTITLE: '다시 인증해 주세요.',
	CONFIRM: '확인',
};

/** 회원 탈퇴 - 탈퇴 신청 제출 결과 안내 메시지 */
export const WITHDRAW_SUBMIT_MESSAGE = {
	FAIL: '탈퇴가 정상적으로 이루어지지 않았습니다.\n다시 시도해주세요.',
	NETWORK_ERROR: '탈퇴 처리 중 문제가 생겼어요.\n다시 시도해 주세요.',
};

/** 탈퇴 신청 취소 - 안내 메시지 */
export const WITHDRAW_CANCEL_MESSAGE = {
	USER_FETCH_FAIL: '회원 정보를 불러오지 못했습니다.',
};

/** 탈퇴 신청 취소 - 탈퇴 예정일 표기 포맷 */
export const WITHDRAW_CANCEL_DEADLINE_FORMAT = 'YYYY년 M월 D일 H시';

/** 탈퇴 신청 취소 - 약관 페이지 왕복 대비 입력값 임시 보관 유효 시간(분) */
export const WITHDRAW_CANCEL_SESSION_EXPIRE_MINUTES = 30;

/** 회원 탈퇴 - 본인 인증(비밀번호/휴대전화번호) 화면 안내 메시지 */
export const WITHDRAW_VERIFY_MESSAGE = {
	PHONE: {
		INVALID_FORMAT: '번호 형식이 올바르지 않습니다.',
		NOT_REGISTERED: '등록된 휴대전화번호가 아닙니다.',
	},
	CERTIFICATION: {
		SUCCESS: '인증이 완료되었습니다',
		INVALID_CODE: '인증번호를 다시 확인해 주세요.',
		REAPPLY_EXCEEDED: '휴대전화번호를 다시 확인하고 탈퇴를 진행해 주세요.',
	},
	SNS_CERTIFICATION: {
		SUCCESS: '인증이 완료되었습니다.',
		FAIL: '본인인증에 실패했습니다.\n다시 확인해 주세요.',
	},
	PASSWORD: {
		INVALID: '비밀번호를 확인해 주세요.',
		CAPTCHA_REQUIRED: '하단에 버튼을 클릭해 인증 진행 후 시도해 주세요.',
		ERROR: '일시적인 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
	},
};
